/* eslint-disable import/extensions */
import { createApp } from 'vue'
import { plugin, defaultConfig } from '@formkit/vue'
import * as Sentry from '@sentry/vue'

// @ts-expect-error export from cluber lib includes extension
import formkitConfig from '@cluber/carabiner/dist/formkit.config.ts'

import { type RouteLocation } from 'vue-router'
import store from '@core/store'
import router from '@core/router'
import { userAccessValidation } from '@core/modules/Auth/routesGuards'
import { loadAppModules } from '@core/modules/loadModules'
import { handlers } from '@core/msw/handlers'
import i18n from '@core/locales/i18n'
import { allowMSW } from '@core/config'
import { shouldAcceptSentryEvent } from '@libs/sentry'

import App from './App.vue'
import '@cluber/carabiner/dist/carabiner.css'
import '@core/assets/css/main.css'

// REGISTER APP MODULES
loadAppModules()

// REGISTER APP
const app = createApp(App)

// PLUGINS
app.use(store)
app.use(router)
app.use(i18n)
app.use(plugin, defaultConfig(formkitConfig))

// SENTRY
Sentry.init({
  app,
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.VITE_APP_ENV,
  beforeSend(event) {
    if (shouldAcceptSentryEvent(event)) return event
    return null
  },
  integrations: [
    Sentry.browserTracingIntegration({ router }),
    Sentry.replayIntegration(),
  ],
  // Tracing
  sampleRate: 0.25,
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  // tracePropagationTargets: ['localhost', /^https:\/\/cluber\.es\/api/, 'https://staging.api.cluber.dev/api/'],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
})

// Load Mocking service worker in browser mode
if (import.meta.env.MODE !== 'production' && allowMSW) {
  await import('@libs/mockRest/browser').then(msw => msw.loadBrowserMSW(handlers))
}

//* Router
router.beforeEach(async (to: RouteLocation, from: RouteLocation) => {
  const result = await userAccessValidation(to, from)
  return result
})

// MOUNT APP (when router isReady)
app.mount('#app')
// await router.isReady().then(() => app.mount('#app')) // DON'T REMOVE THIS COMMENT UNTIL PROD DEPLOY
